export default "__VITE_ASSET__BYDO4H8y__"